module.exports = __webpack_public_path__ + "static/media/PyWeather.6d1b1222.jpg";